import migratedRoutesData from '../../../../astro-routes.json'
import {removeTrailingSlash} from './remove-trailing-slash'

// Same repo-root manifest the origin-request Lambda reads (getMigratedRoutes). Bundled at build
// time - keep it a plain static import so the check is synchronous with no per-render work.
// Normalize manifest entries up front (drop non-strings, strip trailing slashes) so a stray
// "/us/legal/" in the manifest still matches a "/us/legal" lookup and matching stays stable.
const migratedRoutes: Set<string> = new Set(
    (Array.isArray(migratedRoutesData.migrated_routes) ? migratedRoutesData.migrated_routes : [])
        .filter((entry): entry is string => typeof entry === 'string')
        .map(removeTrailingSlash),
)

/**
 * True when `path` has been migrated to Astro, per the checked-in astro-routes.json manifest.
 *
 * Gatsby's client-side <Link> navigation renders its own legacy page from page-data.json and never
 * issues a document request, so the origin-request Lambda can't rewrite it to the Astro build in
 * the unified bucket. LocalizedLink uses this to fall back to a hard navigation for migrated routes
 * (mirroring how it already does so for pages with running experiments), ensuring the request
 * reaches the Lambda and the user sees the Astro version.
 *
 * Query strings and hash fragments are stripped before matching, since link targets legitimately
 * carry them (e.g. "/us/legal?ref=footer", "/us/legal#section") and the manifest keys on pathname.
 */
export const isMigratedRoute = (path: string): boolean => {
    if (typeof path !== 'string') return false
    const pathname = removeTrailingSlash(path.split(/[?#]/)[0])
    return migratedRoutes.has(pathname)
}
